export enum ExportFileTypeEnum {
  EXCEL_XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  PDF = 'application/pdf;charset=utf-8'
}
